<template>
  <div class="header" v-bind:class="{'profile-open': profileOpened}">
    <div class="profile" :class="[this.$store.state.color]" v-on:click="openProfile()">
      <img :src="'/static/img/characters/'+$store.state.character+'.png'" />
    </div>


    <div class="profile-card">
      <div>
        <div class="profile xxl" :class="[this.$store.state.color]">
          <img :src="'/static/img/characters/'+$store.state.character+'.png'" />
        </div>

        <div class="stars-counter-large" style="margin: auto; margin-top: -25px; position: relative; z-index:1;"><img src="@/assets/starsPoint.svg" /> {{$store.state.stars || 0}}</div>

        <h2 style="text-align: center;">Mes badges</h2>
        <ul class="badge-list">
          <li v-if="$store.state.badges.peterpan">
            <img src="@/assets/badges/peterpan.png">
          </li>
        </ul>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'profile',

  data: function () {
    return {
      profileOpened: false
    }
  },

  methods: {
    openProfile: function () {
      this.profileOpened = !this.profileOpened
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/profile.vue